import { QUERY_KEYS } from '../../../../consts';
import { luraSignUserService } from '../../../../services';
import { getAtomWithMutation } from '../../../../utils';

export const luraSignUserAtom = getAtomWithMutation({
  mutationKey: QUERY_KEYS.USER.LURA_SIGN_DATA,
  mutationFn: () => luraSignUserService,
  retry: 0,
});
